import Ajax from './ajax';
import ImageService from './image-service';

import WebsiteInfoAjax from '@ajax/website_info';

import jQuery from 'jquery';

let openGraphApiUrl;

function validateImage(img) {
  return new Promise((resolve, _reject) => {
    let imgEl = jQuery('<img/>');
    let timeout = setTimeout(function () {
      imgEl.trigger('error').removeAttr('src');
      resolve(false);
    }, 3000);

    imgEl
      .on('load', function () {
        clearTimeout(timeout);
        resolve(true);
      })
      .on('error', function () {
        clearTimeout(timeout);
        resolve(false);
      })
      .attr('src', img.src);
  });
}

async function loadImagesInBackground(images) {
  return new Promise((resolve, _reject) => {
    var totalCount = 0;

    if (images.length === 0) {
      return resolve(images);
    }

    images.forEach((x) => {
      validateImage(x).then(async function (success) {
        if (success) {
          x.loaded = true;

          try {
            let data = await ImageService.computeImageHash(x.src);
            x.hash = data && data.hash;
            x.transparent = data && data.transparent;
          } catch {}
        } else {
          x.failed = true;
        }

        totalCount += 1;
        if (totalCount >= images.length) {
          resolve(images);
        }
      });
    });
  });
}

async function checkImage(event, img, el, selectedUrls) {
  checkForBadQuality(event, img, el);

  try {
    let data = await ImageService.computeImageHash(img.src);

    if (!selectedUrls.includes(img.src)) {
      img.hash = data && data.hash;
      img.transparent = data && data.transparent;
    }
  } catch {}
}

function checkForBadQuality(event, img, el) {
  let width = el.naturalWidth;
  let height = el.naturalHeight;

  if (width < 275 || height < 275) {
    img.lowRes = true;
  }
}

async function fetchTerm(q) {
  let resp = await Ajax.get({
    url: '/google',
    data: { q: q },
  });

  return resp.result;
}

async function getOpenGraphApiUrl() {
  if (!openGraphApiUrl) {
    let resp = await Ajax.get({ url: '/google/opengraph_api_url' });
    openGraphApiUrl = resp.url;
  }

  return openGraphApiUrl;
}

async function fetchUrl(url, slow) {
  let resp = await WebsiteInfoAjax.get(url, { slow: slow });
  return resp;
}

async function fetchImages(q, totalResults = 10) {
  let resp = await Ajax.get({
    url: '/google/images',
    data: { q: q, total_results: totalResults },
  });

  resp = resp.filter((x) => x && x.src);
  return resp;
}

async function fetchImagesFromUrl(url, _maxReturned) {
  const apiUrl = await getOpenGraphApiUrl();

  return new Promise((resolve, reject) => {
    jQuery.ajax({
      url: `${apiUrl}`,
      tryCount: 0,
      retryLimit: 5,
      data: {
        url: url,
        images: true,
      },
      success: (resp) => {
        let images = (resp && resp.data && resp.data.images) || [];
        images = images
          .filter((i) => i.size >= 10000)
          .map((x) => {
            return { ...x, source: 'url' };
          })
          .sort((a, b) => b.size - a.size);
        resolve(images);
      },
      error: function (err) {
        if (err && err.status === 0) {
          this.tryCount += 1;

          if (this.tryCount < this.retryLimit) {
            setTimeout(() => {
              jQuery.ajax(this);
            }, 1500);
            return;
          }
        }

        reject(err);
      },
    });
  });
}

let urlImageCache = {};

const getImageDimensions = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () =>
      resolve({
        width: img.naturalWidth,
        height: img.naturalHeight,
        url: new URL(url, document.baseURI).href,
      });
    img.onerror = (error) => reject(error);
    img.src = url;
  });
};

async function processImagesFromUrls(imageUrls) {
  let imageRequests = [];
  let images = [];
  for (let index = 0; index < imageUrls.length; index++) {
    imageRequests.push(getImageDimensions(imageUrls[index]));
  }

  let results = await Promise.allSettled(imageRequests);

  results.forEach((result) => {
    if (result.status === 'fulfilled') {
      const image = result.value;
      if (image && image.width > 0 && image.height > 0) {
        if (image.width > 275 && image.height > 275) {
          images.push({
            src: image.url,
            size: image.width * image.height,
            source: 'url',
          });
        }
      }
    }
  });

  return images;
}

async function fetchImagesFromUrlWithCache(url, totalImages, prefetchedImageUrls = null) {
  if (urlImageCache[url]) {
    return urlImageCache[url].waitForProcessing;
  }

  urlImageCache[url] = { processing: true };
  urlImageCache[url]['waitForProcessing'] = new Promise((resolve, _) => {
    let maxIntervalCalls = 600; // 60 seconds
    let int = setInterval(() => {
      let data = urlImageCache[url];

      if (data['processing'] === false) {
        clearInterval(int);
        resolve(data['images']);
      } else {
        maxIntervalCalls -= 1;

        if (maxIntervalCalls <= 0) {
          clearInterval(int);
          resolve([]);
        }
      }
    }, 100);
  });

  if (prefetchedImageUrls) {
    processImagesFromUrls(prefetchedImageUrls).then((resp) => {
      urlImageCache[url]['images'] = resp;
      urlImageCache[url]['processing'] = false;
    });
  } else {
    fetchImagesFromUrl(url, totalImages).then((resp) => {
      urlImageCache[url]['images'] = resp;
      urlImageCache[url]['processing'] = false;
    });
  }

  return urlImageCache[url].waitForProcessing;
}

export default {
  fetchTerm,
  fetchUrl,
  fetchImages,
  fetchImagesFromUrl,
  fetchImagesFromUrlWithCache,
  checkImage,
  loadImagesInBackground,
};
